export const SET_ADDRESS_LINE_1 = 'SET_ADDRESS_LINE_1';
export const SET_ADDRESS_LINE_2 = 'SET_ADDRESS_LINE_2';
export const SET_CITY = 'SET_CITY';
export const SET_STATE = 'SET_STATE';
export const SET_POSTAL_CODE = 'SET_POSTAL_CODE';

export const SET_ADDRESS_LINE_1_ERRORS = 'SET_ADDRESS_LINE_1_ERRORS';
export const SET_ADDRESS_LINE_2_ERRORS = 'SET_ADDRESS_LINE_2_ERRORS';
export const SET_CITY_ERRORS = 'SET_CITY_ERRORS';
export const SET_STATE_ERRORS = 'SET_STATE_ERRORS';
export const SET_POSTAL_CODE_ERRORS = 'SET_POSTAL_CODE_ERRORS';

export const SET_ADDRESS_ERRORS = 'SET_ADDRESS_ERRORS';


// WEBPACK FOOTER //
// ./src/actionTypes/address.js